import { AUTH_TYPE, AuthType } from 'interfaces/authTypes';

interface AuthTypeDetails {
  urlAuthType: AuthType;
  index: number;
}

const getUrlAuthType = (paths: string[]): AuthTypeDetails => {
  if (paths.includes(AUTH_TYPE.AUTH)) {
    return { urlAuthType: AUTH_TYPE.AUTH, index: paths.indexOf(AUTH_TYPE.AUTH) };
  }

  if (paths.includes(AUTH_TYPE.PASSBACK)) {
    return { urlAuthType: AUTH_TYPE.PASSBACK, index: paths.indexOf(AUTH_TYPE.PASSBACK) };
  }

  return { index: -1, urlAuthType: AUTH_TYPE.NONE };
};

interface AuthLink {
  authToken: string;
  path: string;
  urlAuthType: AuthType;
}

export const processAuthLink = (pathname: string): AuthLink => {
  const paths = pathname.split('/');

  const { index, urlAuthType } = getUrlAuthType(paths);
  const token = index > -1 ? paths[index + 1] : '';

  if (index > -1) {
    paths.splice(index, 2);
  }

  const path = paths.filter((item) => item !== '').join('/');

  return { authToken: token, path, urlAuthType };
};
